import { OutreachProgram } from "../types/outreach";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ProgramForm } from "./ProgramForm";

interface EditProgramDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  program: OutreachProgram;
  onSave?: (program: Partial<OutreachProgram>) => void;
}

export function EditProgramDialog({ open, onOpenChange, program, onSave }: EditProgramDialogProps) {
  const handleSubmit = (data: any) => {
    onSave?.({
      ...data,
      id: program.id,
    });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Edit Program</DialogTitle>
        </DialogHeader>

        <ProgramForm
          defaultValues={program}
          onSubmit={handleSubmit}
          onCancel={() => onOpenChange(false)}
          submitLabel="Save Changes"
        />
      </DialogContent>
    </Dialog>
  );
}
